import { useEffect, useRef } from "react";
import { trackProductInsightEvent } from "../../../utils/productInsightTracking";

const getDeviceType = () => {
  if (typeof window === "undefined") return "unknown";
  if (window.innerWidth < 768) return "mobile";
  if (window.innerWidth < 1100) return "tablet";
  return "desktop";
};

/**
 * Records the moment an instant Private Ride quote becomes visible.
 *
 * The database already captures quote creation and quote consumption. This
 * hook adds the separate customer-facing "quote viewed" step required by the
 * Private Rides conversion funnel.
 */
export const usePrivateRideInsightTracking = ({
  quote,
  marketId,
  productCode = 'private_rides',
  isAsap = false,
  isReturnTrip = false,
  returnMode = null,
  campaignCode = null,
}) => {
  const viewedQuoteIds = useRef(new Set());

  useEffect(() => {
    const quoteId = quote?.quote_id;
    const dedupeKey = `${productCode}:${quoteId}`;
    if (!quoteId || viewedQuoteIds.current.has(dedupeKey)) return;

    viewedQuoteIds.current.add(dedupeKey);

    void trackProductInsightEvent({
      productCode,
      eventName: productCode === 'ride_now'
        ? 'ride_now_quote_viewed' : 'private_ride_quote_viewed',
      marketId: marketId || null,
      entityType: "private_ride_quote",
      entityId: quoteId,
      idempotencyKey: `${productCode}:quote:${quoteId}:viewed`,
      properties: {
        device_type: getDeviceType(),
        campaign_code: campaignCode || null,
        is_asap: Boolean(isAsap),
        is_return_trip: Boolean(isReturnTrip),
        return_mode: isReturnTrip ? returnMode : null,
        passenger_total_price: Number(quote?.passenger_total_price || 0),
        distance_km: Number(quote?.distance_km || 0),
        route_duration_minutes: Number(
          quote?.route_duration_minutes ||
            quote?.estimated_duration_minutes ||
            0,
        ),
      },
    });
  }, [
    campaignCode,
    isAsap,
    isReturnTrip,
    marketId,
    productCode,
    quote,
    returnMode,
  ]);
};
